var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"chartStyle",attrs:{"flat":""}},[_c('div',{staticClass:"d-flex justify-space-between"}),_c('v-container',[_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }